export const fileSizeValidation = (file: File, maxFileSize: number) => {
  const fileSizeInMB = Number((file.size / (1024 * 1024)).toFixed(2));
  if (file && maxFileSize < fileSizeInMB) {
    return `حداکثر اندازه فایل میتواند ${maxFileSize} مگابایت باشد`;
  }
};
